import React from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import MastersFilter from '../filters/MastersFilter/MastersFilter';
import ExecutersFilter from '../filters/ExecutersFilter/ExecutersFilter';
import ParentServicesFilter from '../filters/ParentServicesFilter/ParentServicesFilter';
import ServicesFilter from '../filters/ServicesFilter/ServicesFilter';
import StatusesFilter from '../filters/StatusesFilter/StatusesFilter';
import CitiesFilter from '../filters/CitiesFilter/CitiesFilter';
import RegionsFilter from '../filters/RegionsFilter/RegionsFilter';
import StreetsFilter from '../filters/StreetsFilter/StreetsFilter';
import HousesFilter from '../filters/HousesFilter/HousesFilter';
import FlatsFilter from '../filters/FlatsFilter/FlatsFilter';
import MarksFilter from '../filters/MarksFilter/MarksFilter';
import RatingsFilter from '../filters/RatingsFilter/RatingsFilter';
import useRequestsQueryState from '../../hooks/useRequestsQueryState';
import CreationMethodsFilter from '../filters/CreationMethodsFilter/CreationMethodsFilter';
import PrioritiesFilter from '../filters/PrioritiesFilter/PrioritiesFilter';
import CreateUsersFilter from '../filters/CreateUsersFilter/CreateUsersFilter';
import ApplicantsFilter from '../filters/ApplicantsFilter/ApplicantsFilter';
import styles from './FiltersRow.module.scss';
import StagesLifeFilter from '../filters/StagesLifeFilter/StagesLifeFilter';

const FiltersRow = ({ rootClassName, showInLifeCirle }) => {
  const requestsQueryState = useRequestsQueryState();
  const isCounting = useSelector((state) => state.statisticsStore.isCounting);

  return (
    <div className={cn(styles.root, rootClassName)}>
      <div className={styles.container}>
        <CitiesFilter disabled={requestsQueryState?.isFetching || isCounting} />
        <RegionsFilter
          disabled={requestsQueryState?.isFetching || isCounting}
        />
        <StreetsFilter
          disabled={requestsQueryState?.isFetching || isCounting}
        />
        <HousesFilter disabled={requestsQueryState?.isFetching || isCounting} />
        <FlatsFilter disabled={requestsQueryState?.isFetching || isCounting} />
        <CreateUsersFilter
          disabled={requestsQueryState?.isFetching || isCounting}
        />
        <ApplicantsFilter />
        {/* </div> */}
        {/* <div className={styles.container}> */}
        <MastersFilter
          disabled={requestsQueryState?.isFetching || isCounting}
        />
        <ExecutersFilter
          disabled={requestsQueryState?.isFetching || isCounting}
        />
        <ParentServicesFilter
          disabled={requestsQueryState?.isFetching || isCounting}
        />
        <ServicesFilter
          disabled={requestsQueryState?.isFetching || isCounting}
        />
        <StatusesFilter
          disabled={requestsQueryState?.isFetching || isCounting}
        />

        <MarksFilter disabled={requestsQueryState?.isFetching || isCounting} />
        <CreationMethodsFilter
          disabled={requestsQueryState?.isFetching || isCounting}
        />
        <PrioritiesFilter
          disabled={requestsQueryState?.isFetching || isCounting}
        />
        <RatingsFilter
          disabled={requestsQueryState?.isFetching || isCounting}
        />
        {showInLifeCirle && (
          <StagesLifeFilter
            disabled={requestsQueryState?.isFetching || isCounting}
          />
        )}
      </div>
    </div>
  );
};

export default FiltersRow;
